import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import UserTable from "./UserTableColumns";
import axios from "axios";
import Papa from "papaparse";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const UserList = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState("");
  const [filterDates, setFilterDates] = useState("");
  const [filterAction, setFilterAction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState({
    startDate: "",
    endDate: "",
  });

  const [devicesList, setDevicesList] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [user_Id, setuserId] = useState(null);

  const userDetails = JSON.parse(localStorage.getItem("user"));

  const handleDates = (e) => {
    const { name, value } = e.target;
    setDates({
      ...dates,
      [name]: value,
    });
  };

  const toggleFilter = () => {
    if (filterAction) {
      setDates({
        startDate: "",
        endDate: "",
      });
      setFilterDates("");
    } else {
      setFilterDates(dates);
    }
    setFilterAction(!filterAction);
  };

  const userDevice = (userId) => {
    setuserId(userId);

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}user-devices-list`,
        { userId: userId },
        {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      )
      .then((response) => {
        const allDevices = response.data.result || [];

        // Set devices list
        setDevicesList(allDevices);

        // Automatically check devices that are assigned
        const initiallySelected = allDevices
          .filter((device) => device.assigned === true)
          .map((device) => device._id);

        setSelectedDevices(initiallySelected);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeviceCheckboxChange = (deviceId) => {
    setSelectedDevices((prevSelected) => {
      if (prevSelected.includes(deviceId)) {
        // Uncheck
        return prevSelected.filter((id) => id !== deviceId);
      } else {
        // Check
        return [...prevSelected, deviceId];
      }
    });
  };

  const formSubmit = () => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}user-assign-devices`,
        {
          user: user_Id,
          devices: selectedDevices,
        },
        {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.message);
        setTimeout(() => {
          window.$("#exampleModal").modal("hide");
        }, 10000);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      <ToastContainer />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                {/* <div className="card-header py-3 d-flex justify-content-between">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Users List
                  </h6>
                  <div className="d-flex align-items-center">
                    <div className="mx-2 d-flex flex-column">
                      <label htmlFor="end-date" style={{ color: "black" }}>
                        Search:
                      </label>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Enter for search..."
                          name="filter"
                          value={searchData}
                          onChange={(e) => setSearchData(e.target.value)}
                          style={{
                            width: "100%",
                            paddingRight: "2.5rem", // Adjust padding for button space
                          }}
                        />
                        {searchData && (
                          <button
                            type="button"
                            onClick={() => setSearchData("")}
                            style={{
                              position: "absolute",
                              right: "0.5rem",
                              top: "50%",
                              transform: "translateY(-50%)",
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              fontSize: "1.2rem",
                              color: "#6c757d",
                            }}
                            aria-label="Clear"
                          >
                            ✖
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="mx-0.5 d-flex flex-column">
                      <label htmlFor="start-date" style={{ color: "black" }}>
                        Start Date:
                      </label>
                      <input
                        type="date"
                        placeholder="Enter for search..."
                        name="startDate"
                        value={dates.startDate}
                        onChange={handleDates}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="mx-2 d-flex flex-column">
                      <label htmlFor="end-date" style={{ color: "black" }}>
                        End Date:
                      </label>
                      <input
                        type="date"
                        placeholder="Enter for search..."
                        name="endDate"
                        value={dates.endDate}
                        onChange={handleDates}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div style={{ position: "relative", top: "15px" }}>
                      <button
                        className="btn btn-primary"
                        onClick={toggleFilter}
                        style={{ whiteSpace: "nowrap", width: "145px" }}
                        disabled={!(dates.startDate && dates.endDate)}
                      >
                        {filterAction ? "Clear Filter" : "Apply Date Filter"}
                      </button>
                    </div>
                  </div>
                </div> */}
                <div className="card-body">
                  <div className="table-responsive">
                    {loading && (
                      <div className="loader-container">
                        <div
                          className="spinner-border text-primary loader"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    )}
                    <UserTable
                      containerId="containerA"
                      action={filterAction}
                      filter={searchData}
                      dates={filterDates}
                      userDevice={userDevice}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="sticky-footer bg-white">
            <div className="container my-auto">
              <div className="copyright text-center my-auto">
                <span>Copyright &copy; Blue Iris Software Trading LLC</span>
              </div>
            </div>

            {/* devices modal */}

            <div
              className="modal fade"
              id="exampleModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Update Devices
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body row">
                    {devicesList?.map((device, index) => (
                      <div className="col-sm-3 form-check pl-5" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`device-checkbox-${device._id}`}
                          checked={selectedDevices.includes(device._id)}
                          onChange={() =>
                            handleDeviceCheckboxChange(device._id)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`device-checkbox-${device._id}`}
                        >
                          {device.name}
                        </label>
                      </div>
                    ))}
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={() => {
                        formSubmit();
                      }}
                      className="btn btn-primary"
                    >
                      Save changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default UserList;
